export enum LOCAL_STORAGE_KEYS {
  UserStore = "userStore",
  HrIntegrationBannerClosed = "hr-integration-banner-v2-closed",
  BenefitsMarketplaceBannerClosed = "benefits-marketplace-banner-closed",
  OpenEnrollmentChecklistBannerClosed = "open-enrollment-checklist-banner-closed",
  OpenEnrollmentChecklistShareResourcesStepClicked = "open-enrollment-checklist-share-resources-step-clicked",
  PayrollDeductionStatementReadyBannerClosed = "payroll-deduction-statement-ready-banner-closed",
  MoovVerificationRequirementsReviewed = "moov-verification-requirements-reviewed",
  IchraInvoicingBannerClosed = "ichra-invoicing-banner-closed",
  VitableAiWelcomeModalDismissed = "vita-ai-welcome-modal-dismissed",
  PayFrequencyBannerClosed = "pay-frequency-banner-closed"
}
